import React from 'react';
import { Field } from 'react-final-form';
import CreatableSelect from 'react-select/creatable';

// A reusable custom field component to integrate CreatableSelect with Final Form
const FieldMultiSelectCreate = ({ name, options = [], isMulti = true, validate, label = "" , placeholder="select or add new item" , isCreateNewFieldDisable=false }) => {
  const FieldCreatableSelect = ({ input, meta }) => {
    // Handle onChange for CreatableSelect
    const handleChange = (selectedOptions) => {
      input.onChange(selectedOptions);  // Update Final Form state with the selected options
    };

    const isCreateFieldDisabled = isCreateNewFieldDisable ?  {
      isValidNewOption : () => false,
      formatCreateLabel : () => ""
    } : {};

    return (
      <div>
        {label ? <label>{label}</label> : null}
        <CreatableSelect
          placeholder={placeholder}
          isMulti={isMulti}
          options={options}
          value={input.value}  // Bind the value of CreatableSelect to the form state
          onChange={handleChange}
          onBlur={input.onBlur}  // This ensures Final Form knows when the field is blurred
          onFocus={input.onFocus} // This ensures Final Form knows when the field is focused
          {...isCreateFieldDisabled}
        />
        {/* Display error if the field is touched and has an error */}
        {meta.touched && meta.error && <span>{meta.error}</span>}
        {/* Optionally show warnings */}
        {meta.touched && meta.warning && <span>{meta.warning}</span>}
      </div>
    );
  };

  return (
    <Field
      name={name}  // The name used in the form state
      component={FieldCreatableSelect}  // Use the custom Field component inside the FieldMultiSelectCreate
      options={options}  // Pass the options for CreatableSelect
      isMulti={isMulti}  // Customize multi-select behavior
      validate={validate}  // Pass validation function as a prop
    />
  );
};

export default FieldMultiSelectCreate;
